import Phaser from 'phaser';
import 'regenerator-runtime';

// Interface für eure Highscore-Einträge
type ScoreRecord = {
  name: string;
  score: string;
};

export default class BesteSpieler extends Phaser.Scene {
  constructor() {
    super('bestespieler');
  }

  preload() {
    // hier nichts laden, wir holen in create()
  }

  async create() {
    console.log('Create: fetching highscore data…');

    let highscores: ScoreRecord[] = [];

    try {
      const response = await fetch(
        'https://social.dhbw-stuttgart.de/scores/read.php?game=social'
      );
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      const json = (await response.json()) as {
        data: ScoreRecord[];
        status: string;
      };
      if (Array.isArray(json.data)) {
        highscores = json.data;
      }
    } catch (err) {
      console.error('Failed to load highscores:', err);
    }

    const centerX = this.scale.width / 2;
    const fontSize = Math.min(this.scale.width, this.scale.height) / 24;

    // Stoppt andere Szenen, falls nötig
    this.scene.stop('equipment');

    // Hauptüberschrift
    this.add.text(centerX, 60, '🏅 Die besten SpielerInnen aller Zeiten', {
      fontSize: `${fontSize}px`,
      fontStyle: 'bold',
      color: '#FFD700',
    }).setOrigin(0.5);

    // Untertitel
    this.add.text(
      centerX, 100,
      'Hier findest du die 10 schnellsten SpielerInnen, die das Spiel jemals beendet haben.',
      { fontSize: `${fontSize * 0.7}px`, color: '#ffffff' }
    ).setOrigin(0.5);

    // Spaltenüberschriften
    const col1X = centerX - 150;
    const col2X = centerX + 100;
    this.add.text(col1X, 160, 'Spieler', {
      fontSize: `${fontSize * 0.75}px`,
      color: '#aaaaaa',
      fontStyle: 'bold',
    });
    this.add.text(col2X, 160, 'Zeit (Min:Sek)', {
      fontSize: `${fontSize * 0.75}px`,
      color: '#aaaaaa',
      fontStyle: 'bold',
    });

    // Top 10 in der Reihenfolge vom Server, ohne Sortierung
    highscores
      .slice(0, 10)
      .forEach((rec, idx) => {
        const y = 200 + idx * 35;

        // 1) Rohwert in Zahl konvertieren
        const totalSeconds = Number(rec.score);

        // 2) Minuten und Rest-Sekunden berechnen
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // 3) Sekunden zwei-stellig formatieren
        const timeString = `${minutes}:${seconds.toString().padStart(2, '0')}`;

        // Name wie gehabt
        this.add.text(col1X, y, `${idx + 1}. ${rec.name}`, {
          fontSize: `${fontSize * 0.65}px`,
          color: '#ffffff',
        });

        this.add.text(col2X, y, timeString, {
          fontSize: `${fontSize * 0.65}px`,
          color: '#ffffff',
        });
      });

    // Button zum Abspann (im Stil und an derselben Position wie dein „Spiel beenden“-Button)
    const buttonWidth = this.scale.width / 4.5;
    const buttonHeight = this.scale.height / 15;
    const padding = 20;
    const buttonX = this.scale.width - padding - buttonWidth / 2;
    const buttonY = this.scale.height - padding - buttonHeight / 2;

    const endButton = this.add
      .rectangle(buttonX, buttonY, buttonWidth, buttonHeight, 0x333333)
      .setInteractive()
      .setStrokeStyle(2, 0xffffff)
      .on('pointerover', () => endButton.setFillStyle(0x555555))
      .on('pointerout', () => endButton.setFillStyle(0x333333))
      .on('pointerdown', () => this.scene.start('credits'));

    this.add.text(buttonX, buttonY, 'Weiter zum Abspann', {
      fontSize: `${fontSize * 0.8}px`,
      color: '#ffffff',
    }).setOrigin(0.5);

  }
}
